import { useState, useEffect, useRef, useCallback } from "react";
import "./style.css";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { FormGroup } from "../../../components/FormGroup";
import { Label } from "../../../components/Label";
import { CardContent } from "../../../components/CardContent";
import { Options, Select } from "../../../components/Select";
import { Title } from "../../../components/Title";
import { Subtitle } from "../../../components/SubTitle";
import Search from "../../../components/Search";
import { DeleteModal } from "../../../components/ModalDelete";
import api from "../../../services/api";
import {
  Autocomplete,
  Box,
  CircularProgress,
  IconButton,
  LinearProgress,
  Skeleton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AlertMessage from "../../../components/Alert";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PgrCronograma } from "../Cronograma";
import { FillExcel, FillPen } from "../../../components/Icons";
import DownloadIcon from "@mui/icons-material/Download";
import ExcelQuestor from "../../../img/mockup/excel.png";
import ExcelAtento from "../../../img/mockup/excel-atento.png";
import { Pcmso } from "../../Pcmso";
import { useLocation } from "react-router-dom";
import { Modal as MaterialModal } from "@mui/material";
import { NiveisAcesso } from "../../../constants/niveisAcesso";
import DynamicTable from "../../../components/DynamicTable";
import InputMask from "react-input-mask";
import DeleteIcon from '@mui/icons-material/Delete';
import _ from "lodash";
import useDriver from '../../../hooks/useDriver';

export function PgrFuncao({
  idEmpresa,
  idFdt,
  idRevisao,
  idGhe,
  UpdateComplete,
  selectedEmissaoId,
  documento,
  externoPgr,
  externoPcmso,
  enviado
}: any) {

  interface Exame {
    id: string;
    label: string;
  }

  const [alert, setAlert] = useState({
    show: false,
    message: "",
    variant: "success",
  });
  const [funcoes, setFuncoes]: any = useState([]);
  const [searchTerm, setSearchTerm]: any = useState("");
  const [idBaseFuncao, setBaseFuncao]: any = useState("");
  const [cbo, setCbo]: any = useState("");
  const [descricao, setDescricao]: any = useState("");
  const [numFeminino, setNumFeminino]: any = useState([]);
  const [numMasculino, setNumMasculino]: any = useState([]);
  const [riscos, setRiscos]: any = useState([]);
  const [riscosFiltradosExame, setRiscosFiltradosExame]: any = useState([]);
  const nomeInputRef: any = useRef(null);
  const [isNomeError, setIsNomeError] = useState(false);
  const [editingFuncaoId, setEditingFuncaoId] = useState(null);
  const [showAttachModal, setShowAttachModal] = useState(false);
  const [showInsertRisk, setShowInsertRisk] = useState(false);
  const [editNome, setEditNome] = useState("");
  const [editCbo, setEditCbo] = useState("");
  const [editDescricao, setEditDescricao] = useState("");
  const [editNumFeminino, setEditNumFeminino] = useState("");
  const [editNumMasculino, setEditNumMasculino] = useState("");
  const [editGhe, setEditGhe] = useState("");
  const [progressValue, setProgressValue] = useState(0);
  const [progressModalOpen, setProgressModalOpen] = useState(false);
  const [funcaoSelecionada, setFuncaoSelecionada]: any = useState("");
  const [selectedFuncoes, setSelectedFuncoes]: any = useState([]);
  const [selectedExam, setSelectedExam] = useState<any>();
  const [nivelAcesso, setNivelAcesso] = useState(0);
  const [autocompleteOptions, setAutocompleteOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedGhe, setSelectedGhe] = useState("");
  const [ghes, setGhes]: any = useState([]);
  const [ghesApelidos, setGhesApelidos] = useState<Map<number, string>>();
  const [shouldUpdateRiscos, setShouldUpdateRiscos] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFile, setSelectedFile]: any = useState(null);
  const [collapseStates, setCollapseStates]: any = useState({});
  const [nomecategoria, setNomeCategoria] = useState("");
  const [riscoSelecionado, setRiscoSelecionado]: any = useState(null);
  const [novoNomeRisco, setNovoNomeRisco] = useState("");
  const [novaCategoriaRisco, setNovaCategoriaRisco] = useState("");
  const [risk, setRisk] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [probabilidade, setProbabilidade] = useState("");
  const [severidade, setSeveridade] = useState("");
  const [fonteGeradora, setFonteGeradora] = useState("");
  const [possiveisDanosASaude, setPossiveisDanosASaude] = useState("");
  const [frequencia, setFrequencia] = useState("");
  const [meiosPropagacao, setMeiosPropagacao] = useState("");
  const [medidasDeControlePropostas, setMedidasDeControlePropostas] =
    useState("");
  const [medidasDeControleExistentes, setMedidasDeControleExistentes] =
    useState("");
  const [cronograma, setCronograma] = useState("");
  const [formasDeAcompanhamento, setFormasDeAcompanhamento] = useState("");
  const [afericaoDosResultados, setAfericaoDosResultados] = useState("");
  const [probabilidadePgr, setProbabilidadePgr] = useState("");
  const [severidadePgr, setSeveridadePgr] = useState("");
  const [categorias, setCategorias]: any = useState([]);
  const [categoria, setCategoria]: any = useState([]);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [quarentenaFuncoes, setQuarentenaFuncoes]: any = useState([]);
  const [quarentenaRiscos, setQuarentenaRiscos]: any = useState([]);
  const [quarentenaRiscosEditados, setQuarentenaRiscosEditados]: any = useState(
    []
  );
  const [risco, setRisco] = useState<any>(null);
  const [idCategoria, setIdCategoria] = useState("");
  const [idRisco, setIdRisco] = useState(0);
  const [idBaseRisco, setIdBaseRisco] = useState(0);
  const location = useLocation();
  const pathName = location.pathname;
  const routeName = pathName
    .substring(pathName.lastIndexOf("/") + 1)
    .toUpperCase();
  const [importOption, setImportOption] = useState("Atento");
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [selectedTableType, setSelectedTableType] = useState("");
  const [headerColor, setHeaderColor] = useState("#ccc");
  const [visibleTextareaId, setVisibleTextareaId] = useState<number | null>(null);
  const [funcaoIdSelecionado, setFuncaoIdSelecionado] = useState<number | null>();
  const [idGheEditar, setIdGheEditar] = useState<number>();
  const [riscoAberto, setRiscoAberto] = useState(false);
  const [tipoExame, setTipoExame] = useState({
    admissional: false,
    demissional: false,
    retornoTrabalho: false,
    mudancaFuncao: false,
  });
  const [antes, setAntes] = useState('');
  const [aPartir, setAPartir] = useState('');
  const [periodico, setPeriodico] = useState('');
  const [depois, setDepois] = useState('');
  const [ate, setAte] = useState('');
  const [posAdmissional, setPosAdmissional] = useState('');
  const idadeOpcoes = [{ label: 'N', value: 0 }, ...Array.from({ length: 84 }, (_, i) => ({ label: `${i + 16}`, value: i + 16 }))];
  const mesesOpcoes = [
    { label: '3 meses', value: "3" },
    { label: '6 meses', value: "6" },
    { label: '12 meses', value: "12" },
    { label: '24 meses', value: "24" },
    { label: '36 meses', value: "36" },
    { label: '48 meses', value: "48" },
    { label: '60 meses', value: "60" },
  ];
  const [riscoSelecionadoParaExame, setRiscoSelecionadoParaExame] = useState<any>(null);
  const [fetchedExams, setFetchedExams] = useState<any>([]);
  const [quarentenaExames, setQuarentenaExames] = useState<any>([]);
  const [exameAberto, setExameAberto] = useState(false);
  const [novoExame, setNovoExame] = useState(false);
  const [loading, setLoading] = useState(false);
  const [baseExames, setBaseExames] = useState<Exame[]>([]);
  const [idFuncao, setIdFuncao] = useState<number>();
  const [exameRiscoQuarentena, setExameRiscoQuarentena] = useState(false);
  const [gheApelidos, setGheApelidos]: any = useState([]);
  const currentPath = location.pathname;
  const telaSmall = window.innerWidth < 1920 && window.innerHeight < 1080;
  const { pgrExterno } = useDriver(location.pathname);
  const [todosRiscos, setTodosRiscos]: any[] = useState([])
  const [docsRetorno, setDocsRetorno] = useState([])
  const [showReturnModal, setShowReturnModal] = useState(false)

  const handleExamesPorFuncao = (funcaoId: number) => {
    setIdFuncao(funcaoId);
    if (riscoAberto) setRiscoAberto(false);
    if (funcaoIdSelecionado === funcaoId && exameAberto) {
      setExameAberto(false);
    } else {
      setFuncaoIdSelecionado(funcaoId);
      listRiskByFunction(funcaoId);
      setExameAberto(true);
    }
  }

  const triggerUpdate = useCallback(() => {
    setUpdateTrigger((prev) => !prev);
  }, []);

  const handleInserirFuncao = () => {
    if (riscos.length === 0) {
      setAlert({ show: true, message: "Nenhum risco vinculado à função.", variant: "danger" });
      return;
    }
    setNovoExame(true);
  }

  const filteredFuncoes = funcoes
    .filter((funcao: any) =>
      funcao.cbo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      funcao.AteBaseFuncao.nome.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a: any, b: any) => {
      const gheA = a.pgrGhe.nome.toLowerCase();
      const gheB = b.pgrGhe.nome.toLowerCase();
      return gheA < gheB ? -1 : gheA > gheB ? 1 : 0;
    });
  const [showModalDoc, setShowModalDoc] = useState(false);
  const [showModalEditRisc, setShowModalEditRisc] = useState(false);

  const fetchGhes = async () => {
    try {
      const response = await api.post('listar-pgr', {
        id_empresa: idEmpresa,
        id_fdt: idFdt,
        id_revisao: idRevisao,
        tipo_documento: routeName
      });

      const docsRetorno = response.data.docsRetorno;

      setDocsRetorno(docsRetorno);

      if (docsRetorno && docsRetorno.length > 0) {
        setShowReturnModal(true);
      }

      const responseApelidos = await api.post('buscar-apelidos', {
        id_empresa: idEmpresa,
        id_fdt: idFdt
      });
      setGheApelidos(responseApelidos.data);

      const uniqueGhesMap = new Map();
      response.data.ghes.forEach((ghe: any) => {
        if (!uniqueGhesMap.has(ghe.nome)) {
          uniqueGhesMap.set(ghe.nome, ghe);
        }
      });

      const sortedGhes = Array.from(uniqueGhesMap.values()).filter(ghe => ghe.nome !== "GHE 01").sort((a, b) => {
        return a.nome.localeCompare(b.nome);
      });

      setGhes(sortedGhes);
    } catch (error) {
      console.error('Erro ao buscar GHEs:', error);
    }
  };



  const fetchFuncoes = async () => {
    try {
      const response = await api.post('listar-pgr', {
        id_empresa: idEmpresa,
        id_fdt: idFdt,
        id_revisao: idRevisao,
        id_ghe: idGhe,
        tipo_documento: routeName
      });
      if (response.data && Array.isArray(response.data.funcoes)) {
        setFuncoes(response.data.funcoes);


      } else {
        console.error('Invalid format for funcoes:', response.data.funcoes);
        setFuncoes([]);
      }
    } catch (error) {
      console.error('Erro ao buscar GHEs:', error);
    }
  };

  useEffect(() => {
    if (isNomeError && nomeInputRef.current) {
      nomeInputRef.current.focus();
    }
  }, [isNomeError]);

  useEffect(() => {
    fetchGhes();
    fetchFuncoes();
  }, [idEmpresa, idGhe, idRevisao, idFdt]);

  useEffect(() => {
    handleSearchDynamicTables();
    const fetchNivelAcesso = async () => {
      try {
        const response = await api.get("nivel-acesso");
        setNivelAcesso(response.data.nivel);
      } catch (error) {
        console.error("Erro ao buscar nível de acesso:", error);
      }
    };
    fetchNivelAcesso();
    async function buscarCategorias() {
      try {
        const resposta = await api.get("base-cat-riscos");
        const dados = resposta.data;
        setCategorias(dados);
      } catch (erro) {
        console.error("Erro ao buscar categorias", erro);
      }
    }

    buscarCategorias();
  }, []);

  useEffect(() => {
    api.post("get-quarentena-funcoes", funcoes).then((response: any) => {
      const funcoesQuarentena = response.data.flat();
      setQuarentenaFuncoes(funcoesQuarentena);
    });
  }, [funcoes]);

  useEffect(() => {
    searchQuarentenaRiscos();
  }, [riscos]);

  useEffect(() => {
    const applyQuarantineChanges = () => {
      quarentenaRiscosEditados.forEach((change: any) => {
        const campo = change.coluna;
        const log = JSON.parse(change.log);
        const element = document.getElementById(campo);

        if (element) {
          element.classList.add("quarentena-error", "input");
          element.setAttribute(
            "title",
            `Valor antigo: ${log.valor_antigo}, Valor atual: ${log.valor_atual}`
          );
        }
      });
    };

    applyQuarantineChanges();
  }, [quarentenaRiscosEditados]);

  const toggleFormVisibility = () => {
    setShowForm(!showForm);
  };

  const handleSelectFuncao = (id: number) => {
    const selectedIndex = selectedFuncoes.indexOf(id);
    let newSelectedFuncoes: any = [];

    if (selectedIndex === -1) {
      newSelectedFuncoes = newSelectedFuncoes.concat(selectedFuncoes, id);
    } else if (selectedIndex === 0) {
      newSelectedFuncoes = newSelectedFuncoes.concat(selectedFuncoes.slice(1));
    } else if (selectedIndex === selectedFuncoes.length - 1) {
      newSelectedFuncoes = newSelectedFuncoes.concat(
        selectedFuncoes.slice(0, -1)
      );
    } else if (selectedIndex > 0) {
      newSelectedFuncoes = newSelectedFuncoes.concat(
        selectedFuncoes.slice(0, selectedIndex),
        selectedFuncoes.slice(selectedIndex + 1)
      );
    }

    setSelectedFuncoes(newSelectedFuncoes);
  };

  const simulateProgress = () => {
    let progress = 0;
    const interval = setInterval(() => {
      if (progress < 95) {
        progress += 1.0;
        setProgressValue(progress);
      } else {
        clearInterval(interval);
      }
    }, 800);
  };

  const handleOpenModal = () => {
    if (selectedFuncoes.length > 0) {
      setShowModal(true);
      fetchGhes();
      fetchFuncoes();
    } else {
      setAlert({
        message: "Selecione pelo menos uma função para agrupar.",
        variant: "danger",
        show: true,
      });
    }
  };

  const handleConfirmGrouping = async () => {
    if (!selectedGhe || selectedFuncoes.length === 0) {
      setAlert({
        message:
          "Por favor, selecione uma GHE e pelo menos uma função para agrupar.",
        variant: "danger",
        show: true,
      });
      return;
    }

    const funcoesSelecionadas = funcoes.filter((funcao: any) =>
      selectedFuncoes.includes(funcao.id)
    );

    const nomes = funcoesSelecionadas.map(
      (funcao: any) => funcao.AteBaseFuncao.nome
    );
    const nomesDuplicados = nomes.filter(
      (nome: string, index: number) => nomes.indexOf(nome) !== index
    );

    if (nomesDuplicados.length > 0) {
      setShowModal(false);
      setAlert({
        message: "Não é possível agrupar funções com o mesmo nome.",
        variant: "danger",
        show: true,
      });
      return;
    }

    try {
      const response = await api.post("agrupar-funcoes", {
        id_empresa: idEmpresa,
        id_ghe: selectedGhe,
        id_revisao: idRevisao,
        id_fdt: idFdt,
        id_funcoes: selectedFuncoes,
      });

      if (response.status === 200) {
        setSelectedFuncoes([]);
        fetchGhes();
        fetchFuncoes();
        setAlert({
          message: "Funções agrupadas com sucesso na GHE selecionada.",
          variant: "success",
          show: true,
        });
      } else {
        setAlert({
          message: "Houve um problema ao agrupar as funções. Tente novamente.",
          variant: "danger",
          show: true,
        });
      }
    } catch (error) {
      console.error("Erro ao agrupar funções:", error);
      setAlert({
        message:
          "Erro ao tentar agrupar as funções. Veja o console para mais detalhes.",
        variant: "danger",
        show: true,
      });
    }

    setShowModal(false);
    setSelectedFuncoes([]);
    setSelectedGhe("");
  };

  const debouncedFetchExames = _.debounce(async (nome: string) => {
    if (!nome) return; // Evita buscar se não houver input
    setLoading(true);
    try {
      const response = await api.get(`listar-base-exames/${nome}`);
      setBaseExames(response.data);
    } catch (error) {
      console.error("Erro ao buscar exames:", error);
      setBaseExames([]);
    } finally {
      setLoading(false);
    }
  }, 500); // 500 ms de delay

  const handleConfirmUngroup = async () => {
    if (selectedFuncoes.length == 0) {
      setAlert({
        message: "Por favor, selecione pelo menos uma função para desagrupar.",
        variant: "danger",
        show: true,
      });
      return;
    }

    try {
      const response = await api.post("desagrupar-funcoes", {
        id_empresa: idEmpresa,
        id_revisao: idRevisao,
        id_fdt: idFdt,
        id_funcoes: selectedFuncoes,
      });

      const responseData = response.data;

      setSelectedFuncoes([]);

      if (responseData == false) {
        setAlert({
          message: "Nenhuma função agrupada no momento.",
          variant: "danger",
          show: true,
        });
      } else {
        if (response.status === 200) {
          fetchGhes();
          fetchFuncoes();
          setAlert({
            message: "Funções desagrupadas com sucesso na GHE selecionada.",
            variant: "success",
            show: true,
          });
        } else {
          setAlert({
            message:
              "Houve um problema ao desagrupar as funções. Tente novamente.",
            variant: "danger",
            show: true,
          });
        }
      }
    } catch (error) {
      console.error("Erro ao desagrupar funções:", error);
      setAlert({
        message:
          "Erro ao tentar desagrupar a(s) funções. Veja o console para mais detalhes.",
        variant: "danger",
        show: true,
      });
    }

    setSelectedFuncoes([]);
    setSelectedGhe("");
    fetchGhes();
    fetchFuncoes();
  };

  const handleSearchTermChange = (newSearchTerm: any) => {
    setSearchTerm(newSearchTerm);
  };

  const checkEmptyFields = (campos: { [key: string]: any }): string[] => {
    const emptyFields: string[] = [];

    Object.entries(campos).forEach(([nomeCampo, valorCampo]) => {
      if (
        (typeof valorCampo === "string" && valorCampo.trim() === "") ||
        (typeof valorCampo === "number" && isNaN(valorCampo)) ||
        valorCampo === null ||
        valorCampo === undefined
      ) {
        emptyFields.push(nomeCampo);
      }
    });

    return emptyFields;
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    try {
      const fieldName: { [key: string]: string } = {
        cbo: "CBO",
        descricao: "Descrição",
      };

      const response = await api.post("inserir-funcao", {
        id_empresa: idEmpresa,
        id_fdt: idFdt,
        id_revisao: idRevisao,
        id_ghe: idGhe,
        id_base_funcao: idBaseFuncao,
        cbo,
        descricao,
        num_tra_fem: numFeminino,
        num_tra_masc: numMasculino,
      });

      fetchGhes();
      fetchFuncoes();
      setShouldUpdateRiscos(true);
      UpdateComplete();

      if (response.data.message === "O campo nome é obrigatório.") {
        setIsNomeError(true);
      } else {
        setBaseFuncao("");
        setCbo("");
        setDescricao("");
        setNumFeminino("");
        setNumMasculino("");
        setFuncaoSelecionada("");
      }

      if (nomeInputRef.current) {
        nomeInputRef.current.focus();
      }
    } catch (error) {
      console.error("Erro ao inserir função:", error);
    }
  };

  const handleInsertExam = async () => {
    try {
      const formData = {
        id: selectedExam.id,
        idRevisao: idRevisao
      }
      await api.post(`inserir-exame-geral`, formData);
      setAlert({ message: "Exame vinculado com sucesso!", variant: "success", show: true });
    } catch (error) {
      console.error("Erro ao inserir exame:", error);
    } finally {
      resetForm();
    }
  }

  const resetForm = () => {
    setAPartir('');
    setAte('');
    setPeriodico('');
    setAntes('');
    setPosAdmissional('');
    setSelectedExam(null);
    setTipoExame({
      admissional: false,
      demissional: false,
      retornoTrabalho: false,
      mudancaFuncao: false,
    });
  };

  const listRiskByFunction = async (funcaoId: any) => {
    setIdFuncao(funcaoId);
    const riscosPorFuncao: any = await api.post("listar-riscos-por-funcao", {
      idFuncao: funcaoId,
      idFdt: idFdt,
      idRevisao: idRevisao,
    });

    const responseData = riscosPorFuncao.data.funcao.map((risco: any) => ({
      ...risco,
      isEditable: false,
    }));

    const riscosFiltrados = responseData.filter((risco: any) => risco.id_funcao === funcaoId).map((risco: any) => ({ id: risco.id_base_risco, nome: risco.risco }));

    const examesUnicos = riscosPorFuncao.data.exames.filter((exame: any, index: any, self: any) =>
      index === self.findIndex((e: any) => e.nome === exame.nome)
    );

    setRiscos(responseData);
    setRiscosFiltradosExame(riscosFiltrados);
    setFetchedExams(examesUnicos);
  };

  useEffect(() => {
    listRiskByFunctionAll();
  }, [funcoes, idFdt, idRevisao]);

  const listRiskByFunctionAll = async () => {
    if (funcoes.length > 0) {
      const risksResponses = await Promise.all(
        funcoes.map(async (funcao: { id: any }) => {
          const response: any = await api.post("listar-riscos-por-funcao", {
            idFuncao: funcao.id,
            idFdt: idFdt,
            idRevisao: idRevisao,
          });
          return response.data.funcao.map((risco: any) => ({
            ...risco,
            isEditable: false,
          }));
        })
      );

      const combinedRisks = risksResponses.flat();
      setRiscos(combinedRisks);
      setTodosRiscos(combinedRisks);
    }
  };

  const handleCheckboxChange = (e: any) => {
    const { name, checked } = e.target;
    setTipoExame(prevTipoExame => ({
      ...prevTipoExame,
      [name]: checked
    }));
  };

  const handleRiskDeleteConfirm = async (idFuncao: number) => {
    if (idFuncao) {
      listRiskByFunctionAll()
    }
  };

  const handleDeleteConfirm = async () => {
    fetchGhes();
    fetchFuncoes();
  };

  const startEditing = (funcao: any) => {
    setEditingFuncaoId(funcao.id);
    setEditNome(funcao.id_base_funcao);
    setEditCbo(funcao.cbo);
    setEditDescricao(funcao.descricao);
    setEditNumFeminino(funcao.num_tra_fem);
    setEditNumMasculino(funcao.num_tra_masc);
    setEditGhe(funcao.pgrGhe.apelido ? funcao.pgrGhe.apelido : funcao.pgrGhe.nome);
  };

  const handleListFunction = async (inputValue: any) => {
    if (inputValue.length > 3) {
      const response = await api.get(
        `funcionarios/buscar-funcao/${inputValue}`
      );
      const responseData = response.data;
      setAutocompleteOptions(responseData);
    } else {
      setAutocompleteOptions([]);
    }
  };

  const handleSelectGhe = async (id: any) => {
    const gheSelecionado = ghes.find((ghe: any) => ghe.id === id);
    if (gheSelecionado) {
      setSelectedGhe(id);
    }
  };


  const saveEdits = async () => {
    const updatedFuncao = {
      id_empresa: idEmpresa,
      id_fdt: idFdt,
      id_revisao: idRevisao,
      id_ghe: idGhe,
      id_funcao: editingFuncaoId,
      num_tra_fem: editNumFeminino,
      num_tra_masc: editNumMasculino,
      descricao: editDescricao,
      cbo: editCbo
    };

    const funcao = funcoes.find((f: any) => f.id === editingFuncaoId);
    const body = {
      apelido_ghe: editGhe,
      nome_ghe: funcao.pgrGhe.nome,
      id_ghe: funcao.id_ghe,
      id_empresa: idEmpresa,
      id_fdt: idFdt,
    };

    try {
      const response = await api.post("editar-funcao", updatedFuncao);
      await api.post('editar-nome-ghe', body);
      if (response.data) {
        const updatedFuncoes = funcoes.map((funcao: any) =>
          funcao.id === editingFuncaoId ? { ...funcao, ...updatedFuncao } : funcao
        );
        setFuncoes(updatedFuncoes);
        setEditingFuncaoId(null);
        fetchGhes();
        fetchFuncoes();
        setAlert({
          message: "Função atualizada com sucesso!",
          variant: "success",
          show: true,
        });
      } else {
        console.error("Erro ao editar função:", response.data.message);
        setAlert({
          message: "Erro ao atualizar função.",
          variant: "danger",
          show: true,
        });
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
      setAlert({
        message: "Erro ao tentar enviar os dados.",
        variant: "danger",
        show: true,
      });
    }
  };

  const cancelEditing = () => {
    setEditingFuncaoId(null);
  };

  const handleCloseAttachModal = () => {
    setShowAttachModal(false);
  };

  const handleCloseReturnModal = () => {
    setShowReturnModal(false)
  }

  const handleFileSelection = (event: any) => {
    let file = event.target.files[0];
    setSelectedFile(file);
    if (file) {
      setSelectedFileName(file.name);
    }
  };

  const handleListRisk = async (inputValue: any) => {
    if (inputValue.length > 3) {
      const encodedValue = encodeURIComponent(inputValue);
      const response = await api.get(`buscar-riscos/${encodedValue}`);
      const responseData = response.data;
      setRisk(responseData);
    } else if (inputValue.length < 3) {
      setRisk([]);
    }
  };

  const handleSearchCategory = async (id_cat: any) => {
    const response = await api.get(`listar-categoria/${idEmpresa}/${id_cat}`);
    const responseData = response.data;
    setNovaCategoriaRisco(responseData[0].id);
    setNomeCategoria(responseData[0].categoria);
  };

  const handleRiskSubmit = async (idFuncao: any, idGhe: any) => {
    setShowInsertRisk(false);

    if (!novoNomeRisco.trim()) {
      setAlert({
        message: "Nome e categoria do risco são obrigatórios",
        variant: "danger",
        show: true,
      });
      return;
    }

    try {
      const payload = {
        id: idFuncao,
      };

      await api.post("verificar-riscos-vinculados", payload);

      const response = await api.post("inserir-risco", {
        id_funcao: idFuncao,
        id_empresa: idEmpresa,
        id_fdt: idFdt,
        id_revisao: idRevisao,
        id_ghe: idGhe,
        nome: novoNomeRisco,
        categoria: novaCategoriaRisco,
        editavel: true,
        isManual: true,
      });
      if (response.data) {
        const novoRisco = {
          ...response.data.risco,
          isManual: true,
        };
        listRiskByFunction(idFuncao);
        setRiscos((prevRiscos: any) => [...prevRiscos, novoRisco]);
        setFuncoes(funcoes);
        setNovoNomeRisco("");
        setNovaCategoriaRisco("");
        setRiscoSelecionado(null);
        setNomeCategoria("");
        fetchFuncoes()
      } else {
        console.error("Erro ao inserir risco:", response.data.message);
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
      setAlert({
        message: "Erro ao tentar adicionar o risco. Tente novamente.",
        variant: "danger",
        show: true,
      });
    }
  };

  const handleFileChange = (event: any) => {
    if (selectedFile) {
      setProgressValue(0);
      simulateProgress();
      setShowAttachModal(false);
      setProgressModalOpen(true);

      const reader = new FileReader();
      reader.onload = async (e: any) => {
        const text = e.target.result;

        try {
          const retryRequest = async (
            apiFunc: () => Promise<any>,
            maxAttempts = 3
          ) => {
            for (let attempt = 1; attempt <= maxAttempts; attempt++) {
              try {
                const response = await apiFunc();
                if (response.status === 200) {
                  return response;
                }
              } catch (error) {
                if (attempt === maxAttempts) {
                  throw error;
                }
              }
            }
          };

          const importResponse = await retryRequest(() =>
            api.post("importar-funcoes", { data: text })
          );

          const responseData = importResponse.data;

          const requestFuncionarioBody = {
            data: responseData.funcionarios,
            idEmpresa: idEmpresa,
            idFdt: idFdt,
            idGhe: idGhe,
          };

          const requestFuncaoBody = {
            data: responseData.funcoes,
            idFdt: idFdt,
            idGhe: idGhe,
            idRevisao: idRevisao,
            idEmpresa: idEmpresa,
          };

          const funcionarioResponse = await retryRequest(() =>
            api.post("inserir-funcionario", requestFuncionarioBody)
          );

          const funcaoResponse = await retryRequest(() =>
            api.post("inserir-funcao-auto", requestFuncaoBody)
          );

          setProgressValue(100);
          setProgressModalOpen(false);
          fetchGhes();
          fetchFuncoes();
          setShouldUpdateRiscos(true);

          return responseData;
        } catch (error) {
          console.error(error);
          setProgressValue(100);
          setProgressModalOpen(false);
          setAlert({
            message:
              "Ocorreu um erro após várias tentativas. Por favor, tente importar novamente!",
            variant: "warning",
            show: true,
          });
        }
      };
      reader.readAsText(selectedFile);
    }
  };

  const filteredRiscos = riscos;

  const openModelDoc = async (idModelo: number) => {
    if (idModelo == 2) {
      setImportOption("Atento");
    } else if (idModelo == 3) {
      setImportOption("Questor");
    }
    setShowModalDoc(true);
  };

  const handleEditRisco = async (idRisco: number, idBaseRisco: number) => {
    setIdRisco(idRisco);
    setIdBaseRisco(idBaseRisco);
    try {
      const resposta = await api.get(`listar-risco/${idEmpresa}/${idRisco}`);
      const dados = resposta.data[0];

      if (dados) {
        const categoriaEncontrada = categorias.find(
          (cat: any) => cat.id === dados.categoria
        );
        setCategoria(categoriaEncontrada ? categoriaEncontrada.categoria : "");
        setIdCategoria(dados.categoria);
        setRisco(dados.risco);
        setProbabilidade(dados.probabilidade);
        setSeveridade(dados.severidade);
        setFonteGeradora(dados.fonte_geradora);
        setPossiveisDanosASaude(dados.possiveis_danos_a_saude);
        setMedidasDeControlePropostas(dados.medidas_de_controle_propostas);
        setMedidasDeControleExistentes(dados.medidas_de_controle_existentes);
        setCronograma(dados.cronograma);
        setFormasDeAcompanhamento(dados.formas_de_acompanhamento);
        setAfericaoDosResultados(dados.afericao_dos_resultados);
        setMeiosPropagacao(dados.meio_de_propagacao);
        setProbabilidadePgr(dados.probabilidade_pgr);
        setSeveridadePgr(dados.severidade_pgr);
        setFrequencia(dados.frequencia);
      }
      setShowModalEditRisc(true);
    } catch (erro) {
      console.error("Erro ao buscar dados do risco", erro);
    }
  };

  const handleCloseHelpModal = () => {
    setShowHelpModal(false);
  };

  const getExternoBasedOnRoute = () => {
    if (routeName === "PGR") {
      return externoPgr;
    } else if (routeName === "PCMSO") {
      return externoPcmso;
    }
    return null;
  };

  const externo = getExternoBasedOnRoute();

  const hasQuarantineChangesForRisco = (riscoId: number) => {
    return quarentenaRiscosEditados.some((change: any) => change.id_registro == riscoId);
  };

  const handleDeleteExame = async (exame: any) => {
    setLoading(true);
    try {
      await api.post(`excluir-exame`, { exame: exame, id_revisao: idRevisao, riscos });
      listRiskByFunction(idFuncao);
      setAlert({ show: true, message: "Exame excluído com sucesso!", variant: "success" });
    } catch (error) {
      console.error("Erro ao excluir exame:", error);
      setAlert({ show: true, message: "Erro ao excluir exame.", variant: "danger" });
    } finally {
      setLoading(false);
    }
  };

  function getTooltipTitle(
    funcao: { id: any },
    riscos: any[] | null,
    quarentenaFuncoes: any[],
    quarentenaRiscos: any[],
    nivelAcesso: number
  ) {
    if (!riscos) {
      return nivelAcesso === NiveisAcesso.ADMIN
        ? "Função sem riscos disponíveis"
        : "";
    }

    const isQuarentenaFuncao = quarentenaFuncoes.some(
      (q: { coluna: string; id_registro: any }) =>
        q.id_registro === funcao.id && q.coluna === "id"
    );
    const isQuarentenaDescricao = quarentenaFuncoes.some(
      (q: { id_registro: any; coluna: string }) =>
        q.id_registro === funcao.id && q.coluna === "descricao"
    );
    const isQuarentenaCbo = quarentenaFuncoes.some(
      (q: { id_registro: any; coluna: string }) =>
        q.id_registro === funcao.id && q.coluna === "cbo"
    );
    const isQuarentenaRiscosVinculados = quarentenaFuncoes.some(
      (q: { id_registro: any; coluna: string }) =>
        q.id_registro === funcao.id && q.coluna === "riscos_vinculados"
    );
    const isQuarentenaRisco = (riscos.length > 0) ? riscos.some(
      (risco: { id: any; id_funcao: any }) =>
        quarentenaRiscos.some(
          (q: { id_registro: any }) =>
            q.id_registro === risco.id && risco.id_funcao === funcao.id
        )
    ) : '';
    const hasQuarantineChanges = (riscos.length > 0) ? riscos.some(
      (risco: { id: number; id_funcao: any }) =>
        hasQuarantineChangesForRisco(risco.id) && risco.id_funcao === funcao.id
    ) : '';

    const funcaoTooltipMessage = (() => {
      if (
        isQuarentenaFuncao &&
        isQuarentenaDescricao &&
        isQuarentenaCbo &&
        isQuarentenaRiscosVinculados
      ) {
        return "Função adicionada manualmente, sem descrição, cbo e sem riscos vinculados";
      }
      if (isQuarentenaFuncao && isQuarentenaDescricao && isQuarentenaCbo) {
        return "Função adicionada manualmente, sem descrição e cbo";
      }
      if (
        isQuarentenaFuncao &&
        isQuarentenaDescricao &&
        isQuarentenaRiscosVinculados
      ) {
        return "Função adicionada manualmente, sem descrição e sem riscos vinculados";
      }
      if (
        isQuarentenaFuncao &&
        isQuarentenaCbo &&
        isQuarentenaRiscosVinculados
      ) {
        return "Função adicionada manualmente, sem cbo e sem riscos vinculados";
      }
      if (
        isQuarentenaDescricao &&
        isQuarentenaCbo &&
        isQuarentenaRiscosVinculados
      ) {
        return "Função adicionada sem descrição, cbo e sem riscos vinculados";
      }
      if (isQuarentenaFuncao && isQuarentenaDescricao) {
        return "Função adicionada manualmente e não contém descrição";
      }
      if (isQuarentenaFuncao && isQuarentenaCbo) {
        return "Função adicionada manualmente e não contém cbo";
      }
      if (isQuarentenaFuncao && isQuarentenaRiscosVinculados) {
        return "Função adicionada manualmente e não contém riscos vinculados";
      }
      if (isQuarentenaDescricao && isQuarentenaCbo) {
        return "Função adicionada sem descrição e cbo";
      }
      if (isQuarentenaDescricao && isQuarentenaRiscosVinculados) {
        return "Função adicionada sem descrição e sem riscos vinculados";
      }
      if (isQuarentenaCbo && isQuarentenaRiscosVinculados) {
        return "Função adicionada sem cbo e sem riscos vinculados";
      }
      if (isQuarentenaFuncao) {
        return "Função adicionada manualmente";
      }
      if (isQuarentenaDescricao) {
        return "Função adicionada sem descrição";
      }
      if (isQuarentenaCbo) {
        return "Função adicionada sem cbo";
      }
      if (isQuarentenaRiscosVinculados) {
        return "Função não contém riscos vinculados";
      }
      return "";
    })();

    const riscoTooltipMessage =
      isQuarentenaRisco && hasQuarantineChanges
        ? "Risco adicionado manualmente e editado"
        : isQuarentenaRisco
          ? "Risco adicionado manualmente"
          : hasQuarantineChanges
            ? "Risco editado"
            : "";

    return nivelAcesso === NiveisAcesso.ADMIN
      ? funcaoTooltipMessage || riscoTooltipMessage
      : "";
  }


  const handleTabelaRisco = (funcaoId: any) => {
    if (exameAberto) setExameAberto(false);
    if (funcaoIdSelecionado === funcaoId) {
      setFuncaoIdSelecionado(null);
      setRiscoAberto(false);
    } else {
      setFuncaoIdSelecionado(funcaoId);
      listRiskByFunction(funcaoId);
      setRiscoAberto(true);
    }
  }

  const formatarPeriodicidade = (exame: any) => {
    const partes = [];
    const { periodicidade_a, per_id1, periodicidade, per_id2, Periodicidade_d } = exame;

    // Antes
    if (periodicidade_a > 0 && per_id1 > 0) {
      partes.push(`${periodicidade_a} meses até ${per_id1} anos`);
    }

    // Periodicidade entre "a partir" e "até"
    if (periodicidade > 0 && per_id1 > 0 && per_id2 > 0) {
      partes.push(`${periodicidade} meses de ${per_id1} anos até ${per_id2} anos`);
    } else if (periodicidade > 0 && per_id1 === 0 && per_id2 > 0) {
      // Caso especial onde só temos "até"
      partes.push(`${periodicidade} meses até ${per_id2} anos`);
    } else if (periodicidade > 0 && per_id1 > 0 && per_id2 === 0) {
      // Caso especial onde só temos "a partir"
      partes.push(`${periodicidade} meses a partir de ${per_id1} anos`);
    } else if (periodicidade > 0 && per_id1 === 0 && per_id2 === 0) {
      // Caso especial onde só temos periodicidade
      partes.push(`${periodicidade} meses`);
    }

    // Depois
    if (Periodicidade_d > 0 && per_id2 > 0) {
      partes.push(`${Periodicidade_d} meses a partir de ${per_id2} anos`);
    }

    return partes.join(', ');
  };

  const searchQuarentenaRiscos = () => {
    if (riscos.length > 0) {
      api.post("get-quarentena-riscos", riscos).then((response: any) => {
        const riscosQuarentena = response.data.flat();
        setQuarentenaRiscos(riscosQuarentena);
      });
    }
  };

  const handleSearchDynamicTables = async () => {
    const response = await api.get("buscar-tabela-padrao");
    const responseData = response.data[0];

    setSelectedTableType(responseData.tipo);
    setHeaderColor(responseData.cor);
  };

  const handleIsDescriptionVisible = (id: number | null) => visibleTextareaId === id;

  return (
    <div>
      <div>
        {/* {externo == 1 ? (
          <div style={{ position: "relative", width: "100%" }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={400}
              animation="wave"
              style={{ backgroundColor: "#E6E6E6", borderRadius: "10px" }}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                textAlign: "center",
                color: "grey",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              Para mais funcionalidades, adquira uma revisão ou inicie uma nova
              frente de trabalho.
            </div>
          </div>
        ) : ( */}
        <div id={!pgrExterno ? 'pgrStep3' : ''}>
          <CardContent>
            <Row>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Title text="Funções" />
                <Button
                  style={{
                    width: "40px",
                    borderRadius: "20px",
                  }}
                  onClick={() => setShowHelpModal(true)}
                >
                  ?
                </Button>
              </Box>
              <p
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginLeft: "0.2%",
                }}
              >
                Ajuda
              </p>
            </Row>
            {((externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
              <>
                <div className="buttons">
                  <Subtitle text="Inserir Nova Função" />
                  <Button onClick={() => setShowAttachModal(true)}>
                    <AttachFileIcon />
                    Importar Funções
                  </Button>

                  <Button
                    variant="primary"
                    className="manuallyFunction"

                    onClick={toggleFormVisibility}
                  >
                    Inserir Funções Manualmente
                    <ExpandMoreIcon />
                  </Button>
                </div>

                <Row className="mt-2">
                  <Col xs={12}>
                    <Form.Check
                      type="radio"
                      label={
                        <>
                          Importar usando o modelo Atento
                          <Tooltip title="Ver Modelo">
                            <IconButton
                              className="iconButtonFixedColor"
                              onClick={() => openModelDoc(2)}
                            >
                              <FillExcel />
                              <DownloadIcon style={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        </>
                      }
                      name="importOption"
                      value="Atento"
                      checked={importOption === "Atento"}
                      onChange={(e: any) => setImportOption(e.target.value)}
                    />
                  </Col>
                  <Col xs={12}>
                    <Form.Check
                      type="radio"
                      label={
                        <span>
                          Importar usando o modelo Questor
                          <Tooltip title="Ver Modelo">
                            <IconButton
                              className="iconButtonFixedColor"
                              onClick={() => openModelDoc(3)}
                            >
                              <FillExcel />
                              <DownloadIcon style={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        </span>
                      }
                      name="importOption"
                      value="Questor"
                      checked={importOption === "Questor"}
                      onChange={(e) => setImportOption(e.target.value)}
                    />
                  </Col>
                </Row>

                <Row className="mt-4">
                  <form
                    onSubmit={handleSubmit}
                    className="collapseFunction"
                    style={{
                      height: showForm ? "300px" : "0",
                      overflow: "hidden",
                      transition: ".3s",
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <FormGroup className="form-group-dsg">
                          <Label title="Nome (DIGITE E SELECIONE)" htmlFor="inf" />
                          <Autocomplete
                            value={funcaoSelecionada}
                            onChange={(event, newValue) => {
                              setFuncaoSelecionada(newValue);
                              if (newValue) {
                                setBaseFuncao(newValue.id);
                                setCbo(newValue.cbo ? newValue.cbo : "");
                                setDescricao(
                                  newValue.descricao ? newValue.descricao : ""
                                );
                              } else {
                                setBaseFuncao("");
                                setCbo("");
                                setDescricao("");
                              }
                            }}
                            onInputChange={(event, newInputValue) => {
                              handleListFunction(newInputValue);
                            }}
                            noOptionsText="Digite e selecione"
                            style={{ width: "100%", height: "40px" }}
                            getOptionLabel={(option) => (option ? option.nome : "")}
                            renderInput={(params) => (
                              <TextField {...params} label="" />
                            )}
                            options={autocompleteOptions}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="form-group-dsg">
                          <div className="cboInput">
                            <Label title="CBO" htmlFor="cbo" />
                            <input
                              type="text"
                              id="cbo"
                              placeholder=""
                              value={cbo}
                              onChange={(e) => setCbo(e.target.value)}
                              style={{ width: "100%", height: "56px" }}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="my-4">
                      <Col md={12}>
                        <FormGroup className="form-group-dsg">
                          <Label title="DESCRIÇÃO" htmlFor="desc" />
                          <textarea
                            id="desc"
                            placeholder=""
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            style={{ width: "100%" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup className="form-group-dsg">
                          <Label
                            title="NÚMERO DE TRABALHADORES FEMININOS"
                            htmlFor="fem"
                          />
                          <input
                            type="number"
                            id="fem"
                            placeholder=""
                            value={numFeminino}
                            onChange={(e) => setNumFeminino(e.target.value)}
                            style={{ width: "100%" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={5}>
                        <FormGroup className="form-group-dsg">
                          <Label
                            title="NÚMERO DE TRABALHADORES MASCULINOS"
                            htmlFor="masc"
                          />
                          <input
                            type="number"
                            id="masc"
                            placeholder=""
                            value={numMasculino}
                            onChange={(e) => setNumMasculino(e.target.value)}
                            style={{ width: "100%" }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={1}>
                        <div className="d-grid justify-content-center">
                          &nbsp;
                          <Button className="btn-success" type="submit">
                            Inserir
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </Row>
              </>
            )}

            <Row className="my-4">
              <Col md={8}>
                <Subtitle text="Funções cadastradas" />
              </Col>
              <Col md={4}>
                <Search
                  placeHolder="Procure por Nome ou CBO"
                  onChange={handleSearchTermChange}
                />
              </Col>
            </Row>
            <Row style={{ overflow: 'auto' }}>
              <div className="pgr-funcao-table-container">
                <table className="pgr-funcao-table">
                  <thead style={{ position: 'sticky', top: 0 }}>
                    <tr>
                      <th className="pgr-funcao-th">Selecionar</th>
                      <th className="pgr-funcao-th pgr-funcao-th-borders">Nome</th>
                      <th className="pgr-funcao-th pgr-funcao-th-borders">CBO</th>
                      <th className="pgr-funcao-th pgr-funcao-th-borders">GHE</th>
                      <th className="pgr-funcao-th pgr-funcao-th-borders">Nº Masc.</th>
                      <th className="pgr-funcao-th pgr-funcao-th-borders">Nº Fem.</th>
                      <th className={visibleTextareaId ? "pgr-funcao-th pgr-funcao-th-descricao pgr-funcao-th-borders" : "pgr-funcao-th pgr-funcao-th pgr-funcao-th-borders"}>Descrição</th>
                      <th className="pgr-funcao-th">Ações</th>
                    </tr>
                  </thead>
                  {filteredFuncoes.length > 0 ? (
                    filteredFuncoes.map((funcao: any) => {
                      let isQuarentenaFuncao, isQuarentenaRisco, hasQuarantineChanges = false;
                      let tooltipTitle, tooltipMessage = "";
                      if (nivelAcesso == NiveisAcesso.ADMIN) {
                        isQuarentenaFuncao = quarentenaFuncoes.some((q: any) => q.id_registro === funcao.id);
                        isQuarentenaRisco = (riscos.length > 0) ? riscos.some((risco: any) => quarentenaRiscos.some((q: any) => q.id_registro === risco.id && risco.id_funcao === funcao.id)) : '';
                        hasQuarantineChanges = (riscos.length > 0) ? riscos.some((risco: any) => hasQuarantineChangesForRisco(risco.id) && risco.id_funcao === funcao.id) : '';
                        tooltipTitle = getTooltipTitle(funcao, riscos, quarentenaFuncoes, quarentenaRiscos, nivelAcesso);
                        if (isQuarentenaRisco && hasQuarantineChanges) {
                          tooltipMessage = "Risco adicionado manualmente e editado";
                        } else if (isQuarentenaRisco) {
                          tooltipMessage = "Risco adicionado manualmente";
                        } else if (hasQuarantineChanges) {
                          tooltipMessage = "Risco editado";
                        } else {
                          tooltipMessage = "";
                        }
                      }
                      return (
                        <>
                          <tbody>
                            {/* MODO EDITAR */}
                            {editingFuncaoId === funcao.id ? (
                              <>
                                <tr>
                                  <td className="pgr-funcao-td pgr-funcao-td-top-bottom-border">
                                    <input type="checkbox" className="pgr-funcao-checkbox-style"
                                      checked={selectedFuncoes.indexOf(funcao.id) !== -1}
                                      onChange={() => handleSelectFuncao(funcao.id)}
                                    />
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">{funcao.AteBaseFuncao.nome}</td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <InputMask className="editInput" style={{ maxWidth: '100px', textAlign: 'center' }}
                                      mask="9999-99"
                                      value={editCbo}
                                      placeholder="____-__"
                                      onChange={(e: any) => setEditCbo(e.target.value)} />
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <input type="text" value={editGhe}
                                      onChange={(e) => { setEditGhe(e.target.value); setIdGheEditar(funcao.pgrGhe.id); }}
                                      className="editInput" style={{ width: '100px', textAlign: 'center' }} />
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <input type="text" value={editNumMasculino}
                                      onChange={(e) => setEditNumMasculino(e.target.value)}
                                      className="editInput" style={{ width: "5px", textAlign: "center" }}
                                    />
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <input type="text" value={editNumFeminino}
                                      onChange={(e) => setEditNumFeminino(e.target.value)}
                                      className="editInput" style={{ width: "5px", textAlign: "center" }}
                                    />
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-textarea pgr-funcao-td-borders">
                                    <textarea onChange={(e) => setEditDescricao(e.target.value)} value={editDescricao} style={{ resize: 'none', height: '100px' }} />
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <div style={{ display: 'flex', gap: '5px', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                      <Button onClick={saveEdits} style={{ fontSize: '14px', width: '95px' }}>Salvar</Button>
                                      <Button variant="secondary" onClick={cancelEditing} style={{ fontSize: '14px', width: '95px' }}>Cancelar</Button>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <>
                                {/* MODO VISUALIZAR */}
                                <tr className={isQuarentenaFuncao ? "quarentena-error" : ""}>
                                  <td className="pgr-funcao-td pgr-funcao-td-top-bottom-border">
                                    <Tooltip title={tooltipTitle} placement="left">
                                      <div className="pgr-funcao-checkbox-container">
                                        <input type="checkbox" className="pgr-funcao-checkbox-style"
                                          checked={selectedFuncoes.indexOf(funcao.id) !== -1}
                                          onChange={() => handleSelectFuncao(funcao.id)}
                                        />
                                      </div>
                                    </Tooltip>
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <div>
                                      <Tooltip title={tooltipTitle} placement="left">
                                        {funcao.AteBaseFuncao.nome}
                                      </Tooltip>
                                    </div>
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <div>
                                      <Tooltip title={tooltipTitle} placement="left">
                                        {funcao.cbo}
                                      </Tooltip>
                                    </div>
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <div>
                                      <Tooltip title={tooltipTitle} placement="left">
                                        {gheApelidos.find((ghe: any) => ghe.nome_ghe === funcao.pgrGhe.nome)?.apelido_ghe || funcao.pgrGhe.nome}
                                      </Tooltip>
                                    </div>
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <div>
                                      <Tooltip title={tooltipTitle} placement="left">
                                        {funcao.num_tra_masc}
                                      </Tooltip>
                                    </div>
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-borders">
                                    <div>
                                      <Tooltip title={tooltipTitle} placement="left">
                                        {funcao.num_tra_fem}
                                      </Tooltip>
                                    </div>
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-textarea pgr-funcao-td-borders">
                                    <Tooltip
                                      title={nivelAcesso === NiveisAcesso.ADMIN && (!funcao.descricao || funcao.descricao.trim() === '') ? "Descrição vazia" : ""}
                                      arrow
                                      placement="top"
                                    >
                                      <div className={
                                        nivelAcesso === NiveisAcesso.ADMIN && (!funcao.descricao || funcao.descricao.trim() === '')
                                          ? "quarentena-error pgr-funcao-plus-container"
                                          : "pgr-funcao-plus-container"
                                      }>
                                        {/* <Tooltip title={tooltipTitle} placement="left"> */}
                                        {handleIsDescriptionVisible(funcao.id) ? (
                                          <>
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                                              <button className="pgr-funcao-plus" onClick={() => setVisibleTextareaId(null)}>-</button>
                                              <textarea
                                                readOnly
                                                value={funcao.descricao}
                                                style={{ resize: 'none', width: '130%', height: '100px' }}
                                              />
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <button className="pgr-funcao-plus" onClick={() => setVisibleTextareaId(funcao.id)}>+</button>
                                          </>
                                        )}
                                        {/* </Tooltip> */}
                                      </div>
                                    </Tooltip>
                                  </td>
                                  <td className="pgr-funcao-td pgr-funcao-td-top-bottom-border" style={{ padding: '5px' }}>
                                    <div>
                                      {/* <Tooltip title={tooltipTitle} placement="left"> */}
                                      <div>
                                        {visibleTextareaId ? (
                                          <>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', justifyContent: 'center', alignItems: 'center' }}>
                                              {(externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN && (
                                                <>
                                                  <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Button className="btn btn-outline-primary btn-outline-main" style={{ padding: '3px', width: '50px', fontSize: '16px', height: '35px' }}
                                                      onClick={() => startEditing(funcao)}>
                                                      <FillPen />
                                                    </Button>
                                                    <DeleteModal endpoint="excluir-funcao" onConfirm={handleDeleteConfirm}
                                                      content={<DeleteIcon style={{ fontSize: '16px' }} />}
                                                      style={{ padding: '3px', width: '50px', fontSize: '14px', height: '35px' }}
                                                      requestBody={{
                                                        id_fdt: idFdt,
                                                        id_revisao: idRevisao,
                                                        id_empresa: idEmpresa,
                                                        id_funcao: funcao.id,
                                                      }}
                                                      className="modal-delete-override"
                                                    />
                                                  </div>
                                                </>
                                              )}
                                              <Button className={(isQuarentenaRisco || hasQuarantineChanges) ? "btn quarentena-error" : riscoAberto ? "pgr-funcao-btn-reverse-colors" : "btn"} style={{ fontSize: '14px', width: '110px' }}
                                                onClick={() => { handleTabelaRisco(funcao.id); setRiscoAberto(!riscoAberto); }}>
                                                Riscos
                                              </Button>
                                            </div>
                                          </>
                                        ) : (
                                          <>
                                            <div className="pgr-funcao-td-actions">
                                              {((externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
                                                <>
                                                  <Button className="btn btn-outline-primary btn-outline-main" style={{ padding: '3px', width: '50px', fontSize: '16px', height: '35px' }}
                                                    onClick={() => startEditing(funcao)}>
                                                    <FillPen />
                                                  </Button>
                                                  <DeleteModal endpoint="excluir-funcao" onConfirm={handleDeleteConfirm}
                                                    content={<DeleteIcon style={{ fontSize: '16px' }} />}
                                                    style={{ padding: '3px', width: '50px', fontSize: '14px', height: '35px' }}
                                                    requestBody={{
                                                      id_fdt: idFdt,
                                                      id_revisao: idRevisao,
                                                      id_empresa: idEmpresa,
                                                      id_funcao: funcao.id,
                                                    }}
                                                    className="modal-delete-override"
                                                  />
                                                </>
                                              )}

                                              <Button className={(isQuarentenaRisco || hasQuarantineChanges) ? "btn quarentena-error" : riscoAberto ? "pgr-funcao-btn-reverse-colors" : "btn"} style={{ fontSize: '14px' }}
                                                onClick={() => { handleTabelaRisco(funcao.id); setRiscoAberto(!riscoAberto); }}>
                                                Riscos
                                              </Button>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                      {/* </Tooltip> */}
                                    </div>
                                  </td>
                                </tr>
                              </>
                            )}
                            {funcaoIdSelecionado === funcao.id && (
                              <>
                                <tr>
                                  <td colSpan={8}>
                                    <div className="pgr-funcao-segunda-tabela-container">
                                      {/** SEGUNDA TABELA AQUI */}
                                      <span style={{ marginBottom: '20px' }}>RISCOS</span>
                                      <div style={{ borderRadius: '6px', border: '1px solid #0575E6' }}>
                                        <table className="pgr-funcao-extra-table">
                                          <thead>
                                            <tr>
                                              <th className="pgr-funcao-extra-th">Nome</th>
                                              <th className="pgr-funcao-extra-th pgr-funcao-th-borders">Categoria</th>
                                              <th className="pgr-funcao-extra-th pgr-funcao-th-borders">GHE</th>
                                              <th className="pgr-funcao-extra-th pgr-funcao-th-borders">Frequência</th>
                                              <th className="pgr-funcao-extra-th pgr-funcao-th-borders">Classificações</th>
                                              <th className="pgr-funcao-extra-th">Ações</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {Array.isArray(filteredRiscos) && filteredRiscos.length === 0 ? (
                                              <tr>
                                                <td colSpan={6} className="pgr-funcao-td pgr-funcao-td-segunda-tabela-height pgr-funcao-segunda-tabela-fullwidth">
                                                  <span>Não há riscos disponíveis</span>
                                                </td>
                                              </tr>
                                            ) : (
                                              Array.isArray(filteredRiscos) && filteredRiscos.filter((risco: any) => risco.id_funcao === funcaoIdSelecionado).length > 0 ? (
                                                filteredRiscos.filter((risco: any) => risco.id_funcao === funcaoIdSelecionado).map((risco: any, index: number) => {
                                                  let isQuarentenaRisco, isEdited = false;
                                                  if (nivelAcesso === NiveisAcesso.ADMIN) {
                                                    isQuarentenaRisco = (quarentenaRiscos.length > 0) ? quarentenaRiscos.some((q: any) => q.id_registro === risco.id) : '';
                                                  }
                                                  isEdited = hasQuarantineChangesForRisco(risco.id);
                                                  return (
                                                    <tr key={risco.id} className={isQuarentenaRisco ? "quarentena-error" : ""}>
                                                      <td className="pgr-funcao-extra-td pgr-funcao-td-borders">
                                                        <Tooltip title={isQuarentenaRisco ? tooltipMessage : ""}>
                                                          {risco.risco}
                                                        </Tooltip>
                                                      </td>
                                                      <td className="pgr-funcao-extra-td pgr-funcao-td-borders">
                                                        <Tooltip title={isQuarentenaRisco ? tooltipMessage : ""}>
                                                          {risco.nome_categoria}
                                                        </Tooltip>
                                                      </td>
                                                      <td className="pgr-funcao-extra-td pgr-funcao-td-borders">
                                                        <Tooltip title={isQuarentenaRisco ? tooltipMessage : ""}>
                                                          {(funcao.id === funcaoIdSelecionado && funcao.pgrGhe.apelido) ? funcao.pgrGhe.apelido : risco.nome_ghe}
                                                        </Tooltip>
                                                      </td>
                                                      <td className="pgr-funcao-extra-td pgr-funcao-td-borders">
                                                        <Tooltip title={isQuarentenaRisco ? tooltipMessage : ""}>
                                                          {risco.frequencia ? risco.frequencia : 'Sem frequência'}
                                                        </Tooltip>
                                                      </td>
                                                      <td className="pgr-funcao-extra-td pgr-funcao-td-borders">
                                                        <Tooltip title={isQuarentenaRisco ? tooltipMessage : ""}>
                                                          {risco.classificacao_do_efeito ? risco.classificacao_do_efeito : 'Sem classificação'}
                                                        </Tooltip>
                                                      </td>
                                                      <td className="pgr-funcao-td pgr-funcao-td-actions pgr-funcao-td-borders" style={{ justifyContent: 'center' }}>
                                                        {(nivelAcesso === NiveisAcesso.ADMIN || ((risco.editavel === 1 || risco.editavel === true) && externo != 1)) ? (
                                                          <div className="pgr-funcao-segunda-tabela-acao-div">
                                                            <>
                                                              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                                                                <Button
                                                                  className="pgr-funcao-segunda-tabela-button btn btn-outline-primary btn-outline-main"
                                                                  style={{ width: '115px' }}
                                                                  onClick={() => handleEditRisco(risco.id, risco.id_base_risco)}
                                                                >
                                                                  Editar
                                                                </Button>
                                                                <DeleteModal
                                                                  endpoint="excluir-risco"
                                                                  onConfirm={() => handleRiskDeleteConfirm(risco.id)}
                                                                  style={{ width: '115px' }}
                                                                  requestBody={{
                                                                    id_funcao: funcao.id,
                                                                    id_fdt: idFdt,
                                                                    id_revisao: idRevisao,
                                                                    id_empresa: idEmpresa,
                                                                    id_ghe: risco.id_ghe,
                                                                    id_risco: risco.id,
                                                                  }}
                                                                  className="modal-delete-override"
                                                                />
                                                              </div>
                                                            </>

                                                          </div>
                                                        ) : (
                                                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '85px' }}>
                                                            <p>Não editável</p>
                                                          </div>
                                                        )}
                                                      </td>
                                                    </tr>
                                                  );
                                                })
                                              ) : (
                                                <tr>
                                                  <td colSpan={6} className="pgr-funcao-td pgr-funcao-td-segunda-tabela-height pgr-funcao-segunda-tabela-fullwidth">
                                                    <span>Não há riscos cadastrados</span>
                                                  </td>
                                                </tr>
                                              )
                                            )}

                                            <tr>
                                              {funcaoIdSelecionado && showInsertRisk && (
                                                <>
                                                  <td colSpan={3} className="pgr-funcao-td pgr-funcao-td-segunda-tabela-height pgr-funcao-fullwidth">
                                                    <div>
                                                      <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '6px' }}>
                                                        <Label title="NOME" htmlFor="nomeRisco" />
                                                      </div>
                                                      <Autocomplete value={riscoSelecionado}
                                                        onChange={(event, newValue) => {
                                                          if (newValue) {
                                                            setNomeCategoria("");
                                                            setRiscoSelecionado(newValue);
                                                            setNovoNomeRisco(newValue.nome);
                                                          }
                                                          if (newValue && newValue.id_cat) {
                                                            handleSearchCategory(newValue.id_cat);
                                                          }
                                                        }}
                                                        onInputChange={(event, newInputValue) => { handleListRisk(newInputValue) }}
                                                        noOptionsText="Digite e selecione"
                                                        getOptionLabel={(option) =>
                                                          option ? `${option.nome} - ${option.AteBaseRiscosCat.categoria}` : ""
                                                        }
                                                        getOptionDisabled={(option) =>
                                                          filteredRiscos.some((risco: { id_base_risco: any }) => risco.id_base_risco === option.id)}
                                                        renderInput={(params) => <TextField {...params} label="" />}
                                                        options={risk}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td colSpan={2} className="pgr-funcao-td pgr-funcao-td-segunda-tabela-height pgr-funcao-fullwidth">
                                                    <div>
                                                      <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '6px' }}>
                                                        <Label title="CATEGORIA" htmlFor="catRisco" />
                                                      </div>
                                                      <input style={{ width: '100%', height: '56px', padding: '6px', border: '1px solid grey', borderRadius: '3px' }}
                                                        type="text" id="catRisco" value={nomecategoria}
                                                        onChange={(e) => setNomeCategoria(e.target.value)}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td colSpan={1} className="pgr-funcao-td pgr-funcao-td-segunda-tabela-height pgr-funcao-fullwidth">
                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                      <Button className="btn-success" type="button" style={{ width: '90px' }}
                                                        onClick={() => handleRiskSubmit(funcao.id, funcao.id_ghe)}
                                                      >
                                                        Inserir
                                                      </Button>
                                                    </div>
                                                  </td>
                                                </>
                                              )}
                                            </tr>
                                            <tr style={{ borderTop: '1px solid rgba(128, 128, 128, 0.5)' }}>
                                              <td colSpan={6} className="pgr-funcao-td pgr-funcao-td-segunda-tabela-height pgr-funcao-segunda-tabela-fullwidth">
                                                {((externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
                                                  <Button className="btn-success" onClick={() => setShowInsertRisk(!showInsertRisk)} style={{ width: '115px' }}>
                                                    Novo Risco
                                                  </Button>
                                                )}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </>
                      );
                    })
                  ) : (
                    <>
                      <tr>
                        <td colSpan={8} className="pgr-funcao-td pgr-funcao-td-segunda-tabela-height pgr-funcao-no-data">
                          <span>Não há dados para serem mostrados</span>
                        </td>
                      </tr>
                    </>
                  )}

                </table>
              </div>
              {((externo != 1 && enviado != 1) || nivelAcesso == NiveisAcesso.ADMIN) && (
                <>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: '10px' }}>
                    <Button
                      onClick={handleOpenModal}
                      style={{
                        float: "right",
                        marginTop: "1%",
                        marginRight: "5px",
                      }}
                    >
                      Agrupar
                    </Button>
                    <Button
                      onClick={handleConfirmUngroup}
                      style={{
                        float: "right",
                        marginTop: "1%",
                        backgroundColor: "red",
                        border: "none",
                      }}
                    >
                      Desagrupar
                    </Button>
                  </div>
                </>
              )}

            </Row>
          </CardContent>
        </div>
        {/* )} */}
      </div>
      {routeName === "PCMSO" && (
        <Pcmso
          triggerUpdate={triggerUpdate}
          updateTrigger={updateTrigger}
          idRevisao={idRevisao}
          listaDeRiscos={todosRiscos}
          externoPgr={externo}
          externoPcmso={externoPcmso}
          enviado={enviado}
        />
      )}
      <PgrCronograma
        idEmpresa={idEmpresa}
        idFdt={idFdt}
        idRevisao={idRevisao}
        idGhe={idGhe}
        funcoes={funcoes}
        selectedEmissaoId={selectedEmissaoId}
        documento={documento}
        externoPgr={externo}
        externoPcmso={externoPcmso}
        enviado={enviado}
      />

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Selecionar GHE para Agrupamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Select width="100%" id="ghes" onSelect={handleSelectGhe}>
            {/* AO CARREGAR A PAGINA VERIFICAR SE TEM APELIDO E COLOCAR NO NOME */ghes.map((ghe: any) => (
              <Options key={ghe.id} value={ghe.id} name={ghe.nome} />
            ))}
          </Select>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleConfirmGrouping}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showAttachModal} onHide={() => setShowAttachModal(false)}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <input
            type="file"
            id="fileInput"
            style={{ display: "none" }}
            onChange={handleFileSelection}
          />
          <label
            htmlFor="fileInput"
            style={{
              border: "2px dashed #0d6efd",
              padding: "40px",
              display: "block",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              cursor: "pointer",
              color: "#0d6efd",
              borderRadius: "4px",
              margin: "20px 0",
            }}
          >
            {selectedFileName
              ? `Arquivo selecionado: ${selectedFileName}`
              : "Clique aqui para anexar o documento"}
          </label>
        </Modal.Body>
        <Modal.Footer>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="secondary"
              onClick={() => setShowAttachModal(false)}
              style={{ marginRight: "10px" }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ background: "#009900", color: "#fff" }}
              onClick={handleFileChange}
            >
              Enviar
            </Button>
          </Box>
        </Modal.Footer>
      </Modal>

      <AlertMessage
        show={alert.show}
        message={alert.message}
        variant={alert.variant}
        onClose={() => setAlert({ ...alert, show: false })}
      />
      <Modal
        show={progressModalOpen}
        sx={{ display: "grid", placeItems: "center" }}
        disableEscapeKeyDown={true}
      >
        <Box
          sx={{
            width: "500px",
            p: 3,
            bgcolor: "background.paper",
            borderRadius: "5px",
          }}
        >
          <Typography sx={{ textAlign: "center", paddingbottom: "10px" }}>
            Aguarde, importando documento.
          </Typography>
          <LinearProgress
            variant="determinate"
            value={progressValue}
            sx={{ height: "5px", borderRadius: "3px" }}
          />
        </Box>
      </Modal>

      <Modal show={showAttachModal} onHide={() => setShowAttachModal(false)}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <input
            type="file"
            id="fileInput"
            style={{ display: "none" }}
            onChange={handleFileSelection}
          />
          <label
            htmlFor="fileInput"
            style={{
              border: "2px dashed #0d6efd",
              padding: "40px",
              display: "block",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              cursor: "pointer",
              color: "#0d6efd",
              borderRadius: "4px",
              margin: "20px 0",
            }}
          >
            {selectedFileName
              ? `Arquivo selecionado: ${selectedFileName}`
              : "Clique aqui para anexar o documento"}
          </label>
        </Modal.Body>
        <Modal.Footer>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="secondary"
              onClick={() => setShowAttachModal(false)}
              style={{ marginRight: "10px" }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ background: "#009900", color: "#fff" }}
              onClick={handleFileChange}
            >
              Enviar
            </Button>
          </Box>
        </Modal.Footer>
      </Modal>

      <Modal
        size="lg"
        show={showModalDoc}
        onHide={() => setShowModalDoc(false)}
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          {importOption == "Atento" ? (
            <>
              <img src={ExcelAtento} style={{ width: "100%" }} />
            </>
          ) : (
            <>
              <img src={ExcelQuestor} style={{ width: "100%" }} />
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              href={`${process.env.PUBLIC_URL}/assets/documents/${importOption == "Atento" ? "atento_import.csv" : "questor_import.csv"}`}
              variant="primary"
            >
              Baixar Modelo {importOption == "Atento" ? "Atento" : "Questor"}
            </Button>
            <Button
              variant="secondary"
              onClick={() => setShowModalDoc(false)}
              style={{ marginLeft: "10px" }}
            >
              Cancelar
            </Button>
          </Box>
        </Modal.Footer>
      </Modal>

      <Modal
        size="xl"
        show={showModalEditRisc}
        onHide={() => setShowModalEditRisc(false)}
      >
        <Modal.Header closeButton>
          <b>Editar Risco - {risco}</b>
        </Modal.Header>
        <Modal.Body>
          {selectedTableType && headerColor && (
            <DynamicTable
              type={selectedTableType}
              headerColor={headerColor}
              riscoSelecionado={{
                risco,
                id_base_risco: idBaseRisco,
                id_risco_cadastrado: idRisco,
                id_empresa: idEmpresa,
                categoria,
                fonte_geradora: fonteGeradora,
                possiveis_danos_a_saude: possiveisDanosASaude,
                probabilidade,
                severidade,
                probabilidade_pgr: probabilidadePgr,
                severidade_pgr: severidadePgr,
                medidas_de_controle_existentes: medidasDeControleExistentes,
                medidas_de_controle_propostas: medidasDeControlePropostas,
                cronograma,
                formas_de_acompanhamento: formasDeAcompanhamento,
                afericao_dos_resultados: afericaoDosResultados,
                meio_de_propagacao: meiosPropagacao,
                frequencia,
              }}
              selectedRisco={{
                risco,
                id_base_risco: idBaseRisco,
                id_risco_cadastrado: idRisco,
                id_empresa: idEmpresa,
                categoria,
                fonte_geradora: fonteGeradora,
                possiveis_danos_a_saude: possiveisDanosASaude,
                probabilidade,
                severidade,
                probabilidade_pgr: probabilidadePgr,
                severidade_pgr: severidadePgr,
                medidas_de_controle_existentes: medidasDeControleExistentes,
                medidas_de_controle_propostas: medidasDeControlePropostas,
                cronograma,
                formas_de_acompanhamento: formasDeAcompanhamento,
                afericao_dos_resultados: afericaoDosResultados,
                meio_de_propagacao: meiosPropagacao,
                frequencia,
              }}
              edit={true}
              setShowModal={setShowModalEditRisc}
            />
          )}
        </Modal.Body>
      </Modal>

      <MaterialModal
        open={showHelpModal}
        onClose={handleCloseHelpModal}
        style={{ backdropFilter: "blur(10px)" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            display: "block",
            flexDirection: "column",
            alignItems: "center",
            width: "700px",
            maxWidth: "90%",
            maxHeight: "80%",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <h4>AJUDA</h4>
            <p>
              <b>Cadastro / Listagem de Funções:</b>
            </p>
            <p>
              <b>Inserir Funções:</b> O usuário pode adicionar funções de duas
              formas distintas: a primeira é através da importação de um arquivo
              CSV, empregando Inteligência Artificial com dois modelos
              disponíveis — Modelo Atento e Modelo Questor. A segunda forma é a
              adição manual da função, na qual o usuário seleciona a função
              desejada, insere sua descrição e especifica a quantidade de
              trabalhadores masculinos e femininos.
            </p>
            <p>
              <b>Listagem de Funções:</b> Após o cadastro das funções, seja de
              forma manual ou automática, as funções cadastradas serão exibidas
              em uma tabela contendo os seguintes campos: Selecionar, Nome, CBO,
              GHE, Nº Masc, Nº Fem, Total, Ações. O usuário terá a possibilidade
              de editar ou excluir uma função, além de visualizar os riscos
              previamente vinculados a ela. Além disso, o usuário também poderá
              adicionar novos riscos que considerar necessários.
            </p>
            <p>
              <b>Edição de Riscos:</b> Caso um risco já esteja previamente
              vinculado à função cadastrada automaticamente, o usuário não
              poderá excluí-lo ou editá-lo. Essas ações serão permitidas apenas
              para riscos que tenham sido cadastrados manualmente.
            </p>
            <p>
              <b>Agrupamento de Funções:</b> O usuário poderá agrupar funções de
              acordo com um GHE, possibilitando a vinculação de múltiplas
              funções a um mesmo grupo homogêneo de exposição.
            </p>
          </Box>
        </Box>
      </MaterialModal>
      {nivelAcesso != NiveisAcesso.ADMIN && (
        <MaterialModal
          open={showReturnModal}
          onClose={handleCloseReturnModal}
          style={{ backdropFilter: "blur(10px)" }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              display: "block",
              flexDirection: "column",
              alignItems: "center",
              width: "700px",
              maxWidth: "90%",
              maxHeight: "80%",
              overflow: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
              }}
            >
              <h4>ATENÇÃO</h4>
              <p>Seu documento foi retornado da quarentena com as seguintes observações:</p>

              {/* Mapeia docsRetorno e exibe as observações */}
              {docsRetorno.length > 0 ? (
                <ul>
                  {docsRetorno.map((doc: any, index) => (
                    <li key={index}>
                      {doc.observacao}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>Não há observações para exibir.</p>
              )}

              <p>Você poderá realizar os ajustes e enviar o documento novamente!</p>

            </Box>
          </Box>
        </MaterialModal>
      )}


    </div>
  );
}
